export const AMENDED_APPOINTMENT_MESSAGE =
  'If you have any questions whilst we are processing your request, you can reach out to us on ';
export const AMENDABLE_APPOINTMENT_MESSAGE_START = 'Just ';
export const AMENDABLE_APPOINTMENT_MESSAGE_END =
  ' to reschedule your appointment, or amend your site contact details directly. Or you can contact us on ';
export const AMENDABLE_APPOINTMENT_LINK_TEXT = 'log in';
export const ACCOUNT_URL = '/Account/LoginRedirect.aspx';
export const KCI2_ASSURE_APPOINTMENT_MESSAGE =
  'If you need to change your site contact details or reschedule your appointment, please get in touch.';
export const DISABLED_AMEND_APPOINTMENT_FEATURE_MESSAGE =
  'If you need to reschedule your appointment or change your site contact details, please use ';
export const APPOINTMENT_TODAY_OR_TOMORROW_MESSAGE = "You can't amend your appointment if it's in less than 24 hours.";
